import { useCallback } from 'react'

import { useUserSettings } from '#lib/user-settings/use-user-settings'

export function useLastSelectedRepository(workspaceId: string) {
  const [settings, setUserSettings] = useUserSettings()

  const lastRepoId = settings.lastSelectedRepository[workspaceId] ?? null

  const setLastRepoId = useCallback(
    (repoId: string) => {
      setUserSettings('lastSelectedRepository', {
        ...settings.lastSelectedRepository,
        [workspaceId]: repoId,
      })
    },
    [settings.lastSelectedRepository, workspaceId, setUserSettings],
  )

  return [lastRepoId, setLastRepoId] as const
}
